import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionLabel, Reveal } from "@/components/bits";
import ProductCard from "@/components/ProductCard";

export default function Store() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tab, setTab] = useState("all");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  const tabs = [{ slug: "all", label: "ALL" }, ...categories.map((c) => ({ slug: c.slug, label: c.label }))];
  const filtered = tab === "all" ? products : products.filter((p) => p.category === tab);

  return (
    <div className="pt-32 pb-28 mx-auto max-w-[1400px] px-5 sm:px-8" data-testid="store-page">
      <SectionLabel>FULL CATALOG</SectionLabel>
      <h1 className="mt-4 font-display text-5xl sm:text-7xl uppercase leading-none">The Store</h1>
      <p className="mt-5 max-w-xl text-white/50">Every product is live, secured and auto-delivered. Select a category to filter the arsenal.</p>

      <div className="mt-12 flex flex-wrap gap-3 border-b border-white/10 pb-6" data-testid="store-tabs">
        {tabs.map((t) => (
          <button
            key={t.slug}
            onClick={() => setTab(t.slug)}
            data-testid={`store-tab-${t.slug}`}
            className={`font-mono text-xs tracking-[0.2em] px-5 py-3 rounded-full border transition-colors ${
              tab === t.slug ? "bg-white text-black border-white" : "border-white/15 text-white/60 hover:border-white/50"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 3) * 0.06}><ProductCard p={p} index={i} /></Reveal>
        ))}
      </div>
      {filtered.length === 0 && (
        <div className="py-24 text-center font-mono text-xs tracking-[0.2em] text-white/40">// LOADING ARSENAL...</div>
      )}
    </div>
  );
}
